import axios from '../axiosHelper';
import Cookies from "js-cookie"

export default {
    state: {
        status: '',
        status_code: '',
        message: '',
        message_code: '',
        activityList : [{}],
        userListByLA : [{}],
        userListGraduation : [{}],
        studentProgressList : [{}]
    },
    getters: {
        getStudentProgressList: state => state.studentProgressList,
        getUserListByLA: state => state.userListByLA,
        getUserListGraduation: state => state.userListGraduation,
        getActivityList: state => state.activityList,
    },
    mutations: {
        request(state){
            state.status = 'LOADING'
        },
        success(state, { resp }){
            state.status = 'SUCCESS'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        error(state, { resp }){
            state.status = 'ERROR'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        setActivityList(state, { resp }){
            if (resp) {
                state.activityList = resp.data.data
            }
        },
        setStudentProgressList(state, { resp }){
            if (resp) {
                state.studentProgressList = resp.data.data
            } else {
                state.studentProgressList = [{}]
            }
        },
        setUserListByLA(state, { resp }){
            if (resp) {
                state.userListByLA = resp.data.data
            } else {
                state.userListByLA = [{}]
            }
        },
        setUserListGraduation(state, { resp }){
            if (resp) {
                state.userListGraduation = resp.data.data
            } else {
                state.userListGraduation = [{}]
            }
        },
    },
    actions: {
        getActivityList({commit}, param){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/student-progress/get-learning-activity/'+param.subjectId+'?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setActivityList', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        getStudentProgressList({commit}, param){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/student-progress/'+param.activityId+'/'+param.userId+'/'+param.taId+'?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setStudentProgressList', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        getUserListByLA({commit}, param){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/student-progress/get-user-list/'+param.activityId+'?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setUserListByLA', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        getUserListGraduation({commit}){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/student-progress/get-user-list-graduation?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setUserListGraduation', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
    }
}
